module.exports = __webpack_public_path__ + "static/media/imagenMediumBrown.dbe00dfc.png";